import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { FiltersParams } from './../../models/filters/filters-params.model';
import { UrlController } from './url.controller';

@Directive()
@Injectable()
export class PhFiltersService {
  params: FiltersParams = new FiltersParams();
  filtersEmitter: EventEmitter<PhFiltersDataEmitter> = new EventEmitter();
  urlController: UrlController;
  @Output() filterChange: EventEmitter<any> = new EventEmitter();

  constructor(public baseHttp: BaseHttpService) {
    this.urlController = new UrlController();
  }

  setParams(params) {
    this.filterChange.emit(params);
    Object.assign(this.params, params);
  }

  get() {
    return this.baseHttp.get(this.params.api_url, this.clearParams());
  }

  clearParams() {
    const params = {};
    for (const key in this.params) {
      if (!this.params.hasOwnProperty(key) || key === 'api_url' || this.params[key] === '') {
        continue;
      }
      params[key] = this.params[key];
    }
    for (const key in params) {
      if (this.params.hasOwnProperty(key)) {
        if (Array.isArray(params[key])) {
          params[key] = params[key].join(',');
        }
      }
    }
    return params;
  }
}

export class PhFiltersDataEmitter {
  status: PhFiltersDataStatus = PhFiltersDataStatus.SUCCESS;
  records: any;
  action: PhFiltersAction;
  params?: FiltersParams;

  constructor(data?: any) {
    data ? Object.assign(this, data) : null;
  }
}

export enum PhFiltersDataStatus {
  SUCCESS,
  ERROR,
}

export enum PhFiltersAction {
  LOADING_DATA,
  UPDATE_PARAMS,
  LOAD_MORE,
  MORE_DONE,
}
